import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { SMSDataParams, getSMSData } from 'services/api/getSMSData';
import { queryKeys } from '../queryKeys';

export const useGetSMSData = (params: SMSDataParams, isEnabled = false) => {
    const { data, isLoading, isFetching, ...rest } = useQuery({
        queryKey: queryKeys.smsData(params),
        queryFn: () => getSMSData(params),
        placeholderData: keepPreviousData,
        refetchInterval: isEnabled ? 60000 : false,
        enabled: isEnabled,
    });

    return {
        smsData: data,
        isSMSDataLoading: isLoading,
        isSMSDataFetching: isFetching,
        ...rest,
    };
};
